// @flow

import { createSelector } from 'reselect';

import {
  selectCartConfigurations as selectConfigurations,
  type CartConfiguration,
} from '@gandi/cart';

import type { FullState } from 'src/types';

import type { CreateOrTransfer } from '../../../../types';

const selectProcess = (_: any, process: CreateOrTransfer) => process;
export const selectConfiguration: (
  state: FullState,
  process: CreateOrTransfer,
  // $FlowFixMe[incompatible-call]
) => CartConfiguration = createSelector(
  [selectConfigurations, selectProcess],
  (cartConfigurations, process) =>
    cartConfigurations.find(
      ({ product_type: productType, process: _process }) =>
        productType === 'domain' && _process === process,
    ),
);
